/** Dropdown menu item types */
export const ITEM_SUBMENU = 'submenu';
export const ITEM_DIVIDER = 'divider';
export const ITEM_OPTION = 'option';
/** Dropdown menu value types */
export const VALUE_GENERIC_TOGGLE = 'genericToggle';
export const VALUE_NOTES = 'notes';
export const VALUE_ADD_TO_WATCHLIST = 'addToWatchlist';
export const VALUE_SCHWAB_SSO = 'schwabSso';
export const VALUE_INTEGRATIONS = 'integrations';
export const VALUE_PUSH_TO_IREBAL = 'pushToIRebal';
